import React from 'react';
import { BTN_DARK_THEME, Button, CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { useWindowSize } from '@yme/common/hooks';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { isExternalLink, onOpenWindow } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
import { CardHeaderStyled, CardWrapperStyled, SubTitleStyled } from './styled';
export function TeaserCard({ cardProps }) {
    const { image, title, subtitle, button } = cardProps;
    const { isMobileView } = useWindowSize();
    const onClickHandler = (link) => {
        const isExternal = isExternalLink(link);
        if (isExternal) {
            onOpenWindow(link, BLANK);
        }
        else {
            onOpenWindow(link, SELF);
        }
    };
    // TODO: (D.K.) Obligatoriness - reuse 'TeaserCard Component' from 'molecules' folder instead of this body component
    return (React.createElement(CardWrapperStyled, { bgSrc: image.src },
        React.createElement(FlexWrapper, { justifyContent: "flex-end", height: "100%", flexDirection: "column", paddingDesktop: "0 48px 48px", paddingTablet: "0 24px 24px", paddingMobile: "0 16px 16px" },
            subtitle && React.createElement(SubTitleStyled, { color: colorCoreWhite1000 }, subtitle),
            React.createElement(CardHeaderStyled, { color: colorCoreWhite1000 }, title),
            React.createElement(FlexWrapper, null,
                React.createElement(Button, { buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, size: SIZE_44, label: button.text, colorSchema: BTN_DARK_THEME, width: isMobileView ? '100%' : 'auto', onClick: () => onClickHandler(button.link) })))));
}
